import { useState, useEffect, useRef } from 'react';
import useKeyPress from 'hooks/useKeyPress';
import { useNavigate } from "react-router-dom";
import menus from 'menu-items';
import { useDispatch, useSelector } from 'react-redux';
import { loadMenuItems } from 'store/Shared.Slice';
import { useTranslation } from 'react-i18next';

import {
    Box,
    CssBaseline,
    IconButton,
    Divider,
    Popover,
} from '@mui/material';
import {
    ArrowBack,
    ArrowForward,
} from '@mui/icons-material';

import { MuiDrawer, DrawerHeader } from './Sidebar.Drawer';
import { IconMenu, SectionTooltip, MenuIconList } from './Menu.List';


const iconButtonStyle = {
    color: '#FFF'
};

const Sidebar = ({ open, onDrawerOpen }) => {

    const [drawerOpen, setDrawerOpen] = useState(open);
    const [anchorEl, setAnchorEl] = useState(null);
    const [currentSubMenu, setCurrentSubMenu] = useState(null);

    const { t } = useTranslation();
    const dispatch = useDispatch();
    const drawerRef = useRef(null);
    const navigate = useNavigate();
    const openPopover = Boolean(anchorEl);

    const { menuItem = { items: [] } } = useSelector(state => state.sharedState)

    const onKeyPress = (event) => {
        if (drawerRef.current) {
            drawerRef.current.focus();
        }
    };
    useKeyPress(['m'], onKeyPress);

    const handleClickMenuItem = (url) => {
        navigate(url)
    }

    const handlePopoverOpen = (event) => {
        const targetId = event.currentTarget.id;
        const subMenu = menuItem.items.find(item => item.id === targetId);

        setCurrentSubMenu({ items: subMenu?.children, title: subMenu?.title });
        setAnchorEl(event.currentTarget);

    };

    const handlePopoverClose = () => {
        setAnchorEl(null);
    };

    const handleDrawerOpen = () => {
        setDrawerOpen(true);
        onDrawerOpen(true);
    };

    const handleDrawerClose = () => {
        setDrawerOpen(false);
        onDrawerOpen(false);
    };

    useEffect(() => {
        if (menuItem.items.length === 0) {
            dispatch(loadMenuItems(menus));
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return <Box sx={{ display: 'flex' }}>
        <CssBaseline />
        <MuiDrawer id='ga-sidebar' variant="permanent" open={drawerOpen} onMouseLeave={handlePopoverClose} ref={drawerRef} tabIndex={0}>
            <DrawerHeader>
                <IconButton onClick={drawerOpen ? handleDrawerClose : handleDrawerOpen} sx={iconButtonStyle} data-testid="sidebarToggle">
                    {drawerOpen ? <ArrowBack /> : <ArrowForward />}
                </IconButton>
            </DrawerHeader>
            <Divider />
            <MenuIconList
                menuItem={menuItem}
                drawerOpen={drawerOpen}
                handlePopoverOpen={handlePopoverOpen}
                handlePopoverClose={handlePopoverClose}
                handleClick={handleClickMenuItem}
            />
            {!drawerOpen && (
                <Popover
                    id="mouse-over-popover"
                    sx={{ pointerEvents: 'none' }}
                    open={openPopover}
                    anchorEl={anchorEl}
                    anchorOrigin={{
                        vertical: 'middle',
                        horizontal: 'right',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'left',
                    }}
                    onClose={handlePopoverClose}
                >
                    {currentSubMenu?.items?.length > 0 ? (<IconMenu subMenuList={currentSubMenu} handleClick={handleClickMenuItem} />) : <SectionTooltip title={t(currentSubMenu?.title)} />}
                </Popover>
            )}
        </MuiDrawer>
    </Box>
};

export default Sidebar;
